import React, { useState } from 'react';
import { Button, Divider, Form, Grid, Input, Table } from 'semantic-ui-react';
import { checkPrinter, print } from 'services/printer.service';
import { useAlert } from 'context/AlertProvider';
import { useZebra } from 'context/ZebraProvider';

import {
  getByShipment,
  getContent,
  confirmPrint,
} from 'services/shipment-labels.service';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import './print-label-form.scss';
import { getAllByReferenceOrTracking } from 'services/shipments.service';

export default function ReprintLabelForm({
  isPrinting,
  setIsPrinting,
  placeholder = 'Escanea referencia de seguimiento, número de seguimiento o número de caso',
}) {
  const alert = useAlert();
  const zebra = useZebra();
  const [reference, setReference] = useState('');
  const [packageData, setPackageData] = useState();
  const [labels, setLabels] = useState([]);

  const printLabel = async (id) => {
    try {
      setIsPrinting(true);
      const isAvailable = zebra ? await checkPrinter(zebra) : false;
      if (!isAvailable) {
        alert.current.error(
          'Parece que la impresora por defecto no esta disponible, revise que esta encendida y conectada e intentelo de nuevo.',
        );
        setIsPrinting(false);
        return;
      }
      const {
        data: { content },
      } = await getContent(id);
      await print(zebra, content);
      await confirmPrint(id);
      setIsPrinting(false);
      fetchLabels();
    } catch (error) {
      setIsPrinting(false);

      throw error;
    }
  };

  const fetchLabels = async () => {
    try {
      const { data } = await getAllByReferenceOrTracking(reference);
      const shipment = data[0];

      const { data: labels } = await getByShipment(shipment.reference);

      setPackageData(shipment);
      setLabels(labels);
    } catch (error) {
      alert.current.error(getMessageFromAxiosError(error));
    }
  };

  return (
    <Grid centered columns={1} className="reprint-label-form">
      <Grid.Column>
        <Form>
          <Form.Field>
            <Input
              onChange={(event, data) => {
                setReference(data.value);
              }}
              size="big"
              value={reference}
              autoFocus
              placeholder={placeholder}
              action={{
                color: 'blue',
                labelPosition: 'right',
                disabled: isPrinting || !reference,
                loading: isPrinting,
                icon: 'print',
                content: 'Obtener etiquetas',
                onClick: fetchLabels,
              }}
            />
          </Form.Field>
        </Form>

        {labels?.length > 0 && (
          <>
            <Divider />
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>EAN</Table.HeaderCell>
                  <Table.HeaderCell>Tracking</Table.HeaderCell>
                  <Table.HeaderCell>Nº de expedición</Table.HeaderCell>
                  <Table.HeaderCell>Impresiones</Table.HeaderCell>
                  <Table.HeaderCell>Imprimir</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {labels.map((label) => (
                  <Table.Row>
                    <Table.Cell>{label.ean}</Table.Cell>
                    <Table.Cell>{packageData.tracking}</Table.Cell>
                    <Table.Cell>{packageData.reference}</Table.Cell>
                    <Table.Cell>{label.print_count}</Table.Cell>
                    <Table.Cell>
                      <Button
                        disabled={label.print_count === 0}
                        circular
                        icon="print"
                        onClick={() => {
                          printLabel(label.id);
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </>
        )}
      </Grid.Column>
    </Grid>
  );
}
